import { Select, Spin, Typography } from 'antd';
import type { SelectProps } from 'antd/es/select';
import debounce from 'lodash/debounce';
import React, { useMemo, useRef, useState } from 'react';

const  {Text} = Typography;
export interface DebounceSelectProps<ValueType = any>
    extends Omit<SelectProps<ValueType | ValueType[]>, 'options' | 'children'> {
    fetchOptions: (search: string) => Promise<ValueType[]>;
    debounceTimeout?: number;
    controlName?: string;
    selectOptions?: ValueType[];
    mode?: "tags" | "multiple" | undefined;
    
}


export default function DebounceSelectLookup<
    ValueType extends { key?: string; label: React.ReactNode; value: string | number } = any,
    >({fetchOptions, debounceTimeout = 300, controlName, selectOptions = [], mode,  ...props }: DebounceSelectProps<ValueType>) {
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState<ValueType[]>(selectOptions);
    const fetchRef = useRef(0);
    const debounceFetcher = useMemo(() => {
        const loadOptions = (value: string) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);
            let valueStr = {title: value, controlName: controlName}           
            fetchOptions(JSON.stringify(valueStr)).then(newOptions => {
                if (fetchId !== fetchRef.current) {
                    // for fetch callback order
                    return;
                }

                setOptions(newOptions);
                setFetching(false);
            });
        };

        return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout]);

    return (
        <Select
            mode={mode}
            labelInValue
            showSearch = {true}
            showArrow= {true}
            filterOption={false}
            onSearch={debounceFetcher}
            notFoundContent={fetching ? <Spin size="small" /> : <Text></Text>}
            {...props}
            options={options}
        />
    );
}